/// <reference path="../app.ts" />
namespace Cfnc {
    export interface ILoginScope extends ng.IScope {
        vm: Login;
        loginForm: ng.IFormController;
    }

    export interface ILogin {
        errors: Array<any>;
        busy: boolean;
    }

    export class Login implements ILogin {
        static controllerId: string = "login";
        static $inject: any = ["$scope", "$location", "common", "loginCredentials", "config"];
        errors: Array<any> = [];
        busy: boolean;
        loginInfo: ILoginBindingModel;
        log: (msg, data?, showToast?) => void;
        returnUrl: string;

        constructor(private $scope: ILoginScope, private $location: angular.ILocationService, private common: ICommonFactory, private LoginCredentials: ILoginCredentials, private config: Config) {
            this.log = common.logger.getLogFn(Login.controllerId);
            this.busy = false;
            this.returnUrl = this.$location.search().returnUrl

            window.location.href = this.config.umbracoUrl;



        }

        private activate() {
            var self = this;
            this.common.activateController([], Login.controllerId)
                .then(result => {
                    self.log("Activated Login Screen");

                });
        }



    }


    angular.module("app").controller(Login.controllerId, Login);
}